(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrWorkOrderTypeDeleteController',TrWorkOrderTypeDeleteController);

    TrWorkOrderTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrWorkOrderType'];

    function TrWorkOrderTypeDeleteController($uibModalInstance, entity, TrWorkOrderType) {
        var vm = this;

        vm.trWorkOrderType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrWorkOrderType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
